import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

const CTA = () => {
  return (
    <section className="relative py-32 overflow-hidden bg-gradient-to-br from-gray-900 via-orange-900 to-gray-900">
      {/* Modern Grid Background */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(to right, #f97316 1px, transparent 1px), linear-gradient(to bottom, #f97316 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }}></div>

      {/* Glowing Orbs */}
      <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-orange-500 rounded-full opacity-20 blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-amber-500 rounded-full opacity-20 blur-3xl"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500/20 backdrop-blur-sm rounded-2xl mb-8">
            <Sparkles size={32} className="text-orange-400" />
          </div>

          {/* Modern Typography */}
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-black text-white mb-8 leading-tight">
            Ready to Scale
            <span className="block bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">Your Business?</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
            Join thousands of sellers who trust Cinderhillx for their fulfillment needs. 
            <span className="block mt-2 font-bold text-white">Get started with a free consultation today.</span>
          </p>

          {/* Modern Button Group */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="group bg-gradient-to-r from-orange-500 to-amber-500 text-white px-10 py-5 rounded-xl font-bold text-xl hover:shadow-2xl hover:shadow-orange-500/50 transition-all duration-300 flex items-center space-x-3"
            >
              <span>Get Your Free Quote</span>
              <ArrowRight size={24} className="group-hover:translate-x-2 transition-transform" />
            </Link>
            
            <Link
              to="/services"
              className="bg-white/5 backdrop-blur-sm border-2 border-white/20 text-white px-10 py-5 rounded-xl font-bold text-xl hover:bg-white/10 hover:border-orange-500/50 transition-all duration-300"
            >
              View Our Services
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-gray-400">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-sm font-bold">Dedicated Support</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" style={{animationDelay: '0.3s'}}></div>
              <span className="text-sm font-bold">Quality Focused</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" style={{animationDelay: '0.6s'}}></div>
              <span className="text-sm font-bold">Free Consultation</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;